export default __webpack_public_path__ + "static/media/videos.2e5f7a1b.svg";